import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button, CellContent, TextField } from "@gemini/ui";
import { useCallback, useState } from "react";
import { setRuntimeApplicationVersionQueryParameter, useRuntimeApplication, } from "../../../federation/runtime";
import { List } from "../List";
import { createTabPanel } from "./createTabPanel";
import { useAutofocusRef } from "./useAutofocusRef";
export const ApplicationTabPanel = createTabPanel({
    label: "Application",
    description: "Current application settings",
    Component({ isActive }) {
        const inputRef = useAutofocusRef(isActive);
        const { id: applicationId, version: applicationVersion = "N/A" } = useRuntimeApplication();
        const [applicationVersionInput, setApplicationVersionInput] = useState(applicationVersion);
        const onSubmitHandler = useCallback((e) => {
            e.preventDefault();
            setRuntimeApplicationVersionQueryParameter(applicationVersionInput);
        }, [applicationVersionInput]);
        return (_jsxs(_Fragment, { children: [_jsx(List, { items: [
                        {
                            key: `${applicationId}`,
                            title: "Id",
                        },
                        {
                            key: applicationVersion,
                            title: "Version",
                        },
                    ], renderItem: ({ key, title }) => (_jsx(CellContent, { title: title, description: key }, key)) }), _jsxs(Box, { display: "flex", flexDirection: "row", as: "form", onSubmit: onSubmitHandler, children: [_jsx(TextField, { ref: inputRef, label: { content: "Application version", isHidden: true }, placeholder: "Select application version", onChange: (value) => setApplicationVersionInput(value), isFullWidth: true }), _jsx(Button, { type: "submit", variant: "primary", marginLeft: "spacing.12", children: "Reload" })] })] }));
    },
});
